// authConstants.js

const USER_KEY = "c_portal_user";
const CLIENT_KEY = "c_portal_client";
const USER_TOKEN_KEY = "c_portal_user_token";
const USER_TOKEN_KEY_EXPIRY = "c_portal_user_token_expiry";

export { USER_KEY, USER_TOKEN_KEY, CLIENT_KEY, USER_TOKEN_KEY_EXPIRY };
